import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNeoDashboardHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Camada_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 319 41",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#fff;}.cls-2{fill:#0f5473;}" }) }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M53.06,33.28V11.25c0-2.54,1.86-4.02,3.94-4.02,1.67,0,3,.61,3.83,2.01l10.08,17.29V7.76h5.23V29.79c0,2.54-1.86,3.98-3.87,3.98-1.63,0-3.03-.57-3.87-1.97l-10.08-17.4v18.88h-5.27Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M80.37,23.72c0-5.42,3.94-9.9,9.74-9.9s9.4,4.4,9.4,9.52v1.59h-13.95c.38,2.5,2.31,4.17,5.01,4.17,2.05,0,3.75-.98,4.63-2.73l4.13,2.09c-1.63,3.37-4.74,5.31-8.72,5.31-5.84,0-10.24-4.06-10.24-10.05Zm13.8-1.78c-.23-1.93-1.82-3.41-4.1-3.41s-3.91,1.52-4.28,3.41h8.38Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M102.32,23.84c0-5.42,4.44-9.9,10.16-9.9s10.2,4.51,10.2,9.9-4.44,9.93-10.2,9.93-10.16-4.47-10.16-9.93Zm14.98,.04c0-2.65-2.05-4.85-4.82-4.85s-4.78,2.2-4.78,4.85,2.01,4.85,4.78,4.85,4.82-2.2,4.82-4.85Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M135.36,33.28h-7.96V7.95h8.23c8.04,0,13.46,5,13.46,12.47,0,8.04-6.07,12.85-13.73,12.85Zm.27-23.05h-5.8V31h5.54c6.14,0,11.22-3.91,11.22-10.58,0-6.1-4.55-10.2-10.96-10.2Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M152.67,24.03c0-5.23,4.13-9.56,9.63-9.56s9.67,4.17,9.67,9.56v9.25h-2.24v-4.28c-1.4,2.77-4.25,4.66-7.73,4.66-5.31,0-9.33-4.32-9.33-9.63Zm16.95,.04c0-4.02-3.22-7.36-7.32-7.36s-7.28,3.34-7.28,7.36,3.22,7.36,7.28,7.36,7.32-3.34,7.32-7.36Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M176.26,29.6l1.93-1.06c1.1,2.12,2.81,2.88,5.04,2.88,2.46,0,4.51-1.06,4.51-3.18,0-4.63-10.92-1.4-10.92-8.38,0-3.07,2.81-5.23,6.33-5.23,3,0,5.27,1.29,6.48,3.49l-1.93,1.1c-.99-1.86-2.58-2.39-4.51-2.39-2.05,0-4.02,1.1-4.02,2.99,0,4.48,10.92,1.4,10.92,8.38,0,3.33-3.15,5.42-6.79,5.42-3.11,0-5.69-1.33-7.05-4.02Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M195.2,33.28V6.43h2.35v11.68c1.37-2.16,3.94-3.64,6.94-3.64,5.23,0,8.34,3.68,8.34,9.18v9.63h-2.35v-9.44c0-3.83-2.12-7.13-6.29-7.13-3.83,0-6.64,3.11-6.64,7.32v9.25h-2.35Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M218.11,24.1V6.43h2.35v11.98c1.56-2.35,4.29-3.94,7.39-3.94,5.46,0,9.55,4.21,9.55,9.63s-4.13,9.59-9.63,9.59-9.67-4.21-9.67-9.59Zm16.95,0c0-4.02-3.22-7.39-7.28-7.39s-7.32,3.38-7.32,7.39,3.22,7.35,7.32,7.35,7.28-3.33,7.28-7.35Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M240.76,24.03c0-5.27,4.29-9.56,9.67-9.56s9.63,4.32,9.63,9.56-4.21,9.63-9.63,9.63-9.67-4.32-9.67-9.63Zm16.95,.04c0-4.02-3.22-7.36-7.28-7.36s-7.32,3.34-7.32,7.36,3.22,7.36,7.32,7.36,7.28-3.34,7.28-7.36Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M263.4,24.03c0-5.23,4.13-9.56,9.63-9.56s9.67,4.17,9.67,9.56v9.25h-2.24v-4.28c-1.4,2.77-4.25,4.66-7.73,4.66-5.31,0-9.33-4.32-9.33-9.63Zm16.95,.04c0-4.02-3.22-7.36-7.32-7.36s-7.28,3.34-7.28,7.36,3.22,7.36,7.28,7.36,7.32-3.34,7.32-7.36Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M288.26,33.28v-11.34c0-4.28,2.47-7.32,6.71-7.32,1.14,0,2.24,.23,3.19,.68v2.39c-.91-.53-1.94-.8-3-.8-2.81,0-4.55,2.01-4.55,5.16v11.22h-2.35Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M299.44,24.1c0-5.42,4.1-9.63,9.52-9.63,3.11,0,5.84,1.59,7.39,3.94l.04-11.98h2.35V24.1c0,5.38-4.25,9.59-9.67,9.59s-9.63-4.32-9.63-9.59Zm16.95,0c0-4.02-3.22-7.39-7.32-7.39s-7.28,3.38-7.28,7.39,3.22,7.35,7.28,7.35,7.32-3.33,7.32-7.35Z"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M35.88,0H5.13C3,0,1.18,1.29,.4,3.13c-.26,.61-.4,1.29-.4,2H0v30.75H0s0,0,0,0v5.12H35.88c2.12,0,3.94-1.29,4.72-3.13,.26-.61,.4-1.29,.4-2h0V5.12h0V0h-5.13Z"
		}), /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("ellipse", {
				className: "cls-2",
				cx: 20.5,
				cy: 11.2,
				rx: 3.08,
				ry: 3
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				className: "cls-2",
				cx: 11.27,
				cy: 11.2,
				rx: 3.08,
				ry: 3
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				className: "cls-2",
				cx: 29.72,
				cy: 11.2,
				rx: 3.08,
				ry: 3
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				className: "cls-2",
				cx: 20.5,
				cy: 20.2,
				rx: 3.08,
				ry: 3
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				className: "cls-2",
				cx: 11.27,
				cy: 20.2,
				rx: 3.08,
				ry: 3
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				className: "cls-2",
				cx: 29.72,
				cy: 20.2,
				rx: 3.08,
				ry: 3
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				className: "cls-2",
				cx: 20.5,
				cy: 29.8,
				rx: 3.08,
				ry: 3
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				className: "cls-2",
				cx: 11.27,
				cy: 29.8,
				rx: 3.08,
				ry: 3
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				className: "cls-2",
				cx: 29.72,
				cy: 29.8,
				rx: 3.08,
				ry: 3
			})
		] })] })
	]
});
export default SvgNeoDashboardHome;
